import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';

import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { CalendarModule } from 'primeng/calendar';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

import { SupplierBulkPaymentComponent } from './supplier-bulk-payment.component';
import { AppReportFilterModule } from 'app/modules/reports/components/report-filter/report-filter.module';
import { AppCheckboxModule } from 'app/modules/shared/components/checkbox/checkbox.module';
import { AppInputModule } from 'app/modules/shared/components/input/input.module';
import { SharedModule } from 'app/modules/shared/shared.module';

@NgModule({
  imports: [CommonModule, NgxMaskDirective, NgxMaskPipe, TooltipModule, SharedModule, TableModule, AppReportFilterModule, AppCheckboxModule, AppInputModule, CalendarModule, DateInputsModule,],
  declarations: [SupplierBulkPaymentComponent],
  exports: [SupplierBulkPaymentComponent],
})
export class AppSupplierBulkPaymentModule {}
